import { render, staticRenderFns } from "./currentmonview.vue?vue&type=template&id=747fc848&scoped=true"
import script from "./currentmonview.vue?vue&type=script&lang=js"
export * from "./currentmonview.vue?vue&type=script&lang=js"
import style0 from "./currentmonview.vue?vue&type=style&index=0&id=747fc848&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747fc848",
  null
  
)

export default component.exports